import { OnSendDeleteConfirmation } from '~/features/events';
import { OnSendSharedContextEvent } from './events';

import { sendDeleteConfirmation } from '~/features/utils';
import { BoardCertContext, BoardCertScope } from './types';

export const sendLoadToCrud = ({ context }: { context: BoardCertContext }) => {
  context.crudRef.send({ type: 'ON_LOAD' });
};

export const sendContextToCrud = ({ context }: { context: BoardCertContext }) => {
  context.crudRef.send({
    type: 'ON_SEND_SHARED_CONTEXT',
    values: { providerId: context.providerId },
  });
};

export const setProviderData = (scope: BoardCertScope): Partial<BoardCertContext> => {
  const { values } = scope.event as OnSendSharedContextEvent;
  return {
    providerId: values.providerId,
    providerCategoryId: values.providerCategoryId,
  };
};

export const openConfirmation = (scope: BoardCertScope) => {
  const event = scope.event as OnSendDeleteConfirmation;

  const onConfirm = (id: number) => {
    scope.context.crudRef.send({ type: 'ON_DELETE', payload: { id } });
  };

  const userActor = scope.system.get('userState');
  if (userActor) {
    userActor.send(sendDeleteConfirmation(() => onConfirm(event.payload.id)));
  } else {
    console.warn('[boardCert] Unable to send confirmation - userState not found');
  }
};
